import { useLocation } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { AppRouter } from 'components/appRouter';
import { routes } from 'components/appRouter/routes';
import { HeroSection } from 'components/heroSection';
import { Footer } from 'components/footer';
import Styles from './app.module.scss';

const routesWithoutHeroSection = [
	'/admin',
	'/admin/create-reward',
	'/invitation',
	'/invitation/guest',
	'/invitation/account',
	'/invitation/success',
];

function App() {
	const location = useLocation();

	const isHeroSectionHidden = routesWithoutHeroSection.includes(location.pathname);

	return (
		<div>
			<Toaster
				position='bottom-right'
				toastOptions={{
					style: {
						fontFamily: 'Dark Grotesque, sans-serif',
						border: '1px solid #5e5e5e',
						color: '#fff',
						padding: '16px',
						background: '#1b1b1b',
					},
					error: {
						style: { border: '1px solid #fa003e' }
					},
					success: {
						style: { border: '1px solid #31d366' }
					}
				}}
			/>
			<Layout>
				{ !isHeroSectionHidden && <HeroSection /> }
				<AppRouter routes={routes} />
				<Footer />
			</Layout>
		</div>
	);
}

const Layout = ({ children }) => (
	<div className={Styles.mainContainer}>
		<div className={Styles.contentContainer}>
			{children}
		</div>
	</div>
);

export { App };
